import { feedSearch } from "./feed-search";
import { pagination } from "./pagination";

export const initNewsFeedSearch = () => {
    const newsfeedItems = document.querySelectorAll(
        '[data-selector="newsfeeditem"]',
    );
    const form = document.querySelector<HTMLFormElement>(
        '[data-selector="newsfeed-search-form"]',
    );

    if (!form) return;

    feedSearch({
        formSelector: '[data-selector="newsfeed-search-form"]',
        resultsContainerSelector:
            '[data-selector="newsfeed-search-results-list"]',
        highlightedEntriesWrapperSelector:
            '[data-selector="newsfeed-highlighted-entries"]',
    });
    const loadMoreButtonSelector = '[data-selector="newsfeed-load-more"]';

    pagination({
        loadMoreButtonSelector,
        resultsContainerSelector:
            '[data-selector="newsfeed-search-results-list"]',
    });

    // take the first 2 newsfeed items and add them data-variant="large"
    newsfeedItems.forEach((item, index) => {
        if (index < 2) {
            item.setAttribute("data-variant", "large");
        } else {
            item.setAttribute("data-variant", "small");
        }
    });
};
